// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__2PoKe","info":"PatientInfo_info__9wQ5I"};